import { api } from "./client";
import type { FileDTO, SearchQuery } from "@titancloud/shared";

export async function searchFiles(
  params: Partial<SearchQuery>
): Promise<{ files: FileDTO[]; total: number }> {
  const qs = new URLSearchParams();
  if (params.q) qs.set("q", params.q);
  if (params.ext) qs.set("ext", params.ext);
  if (params.mime) qs.set("mime", params.mime);
  if (params.sort) qs.set("sort", params.sort);
  if (params.order) qs.set("order", params.order);
  if (params.limit) qs.set("limit", String(params.limit));
  if (params.offset) qs.set("offset", String(params.offset));
  return api.get(`/search?${qs.toString()}`);
}
